import { ChainId } from 'vvs-sdk'
import { serializeTokens } from './tokens'
import { SerializedFarmConfig } from './types'

const serializedTokens = serializeTokens()
// FIXME update pid, address and tokens for LP

const mainnetFarms: SerializedFarmConfig[] = [
  /**
   * These 3 farms (PID 0, 251, 252) should always be at the top of the file.
   */
  {
    pid: 0,
    lpSymbol: 'VVS',
    lpAddresses: {
      338: '0x904Bd5a5AAC0B9d88A0D47864724218986Ad4a3a',
      25: '0x2D03bECE6747ADC00E1a131BBA1469C15fD11e03',
    },
    token: serializedTokens.workbench,
    quoteToken: serializedTokens.wcro,
  },
  // {
  //   pid: 251,
  //   lpSymbol: 'CAKE-BNB LP',
  //   lpAddresses: {
  //     338: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
  //     25: '0x0eD7e52944161450477ee417DE9Cd3a859b14fD0',
  //   },
  //   token: serializedTokens.cake,
  //   quoteToken: serializedTokens.wbnb,
  // },
  // {
  //   pid: 252,
  //   lpSymbol: 'BUSD-BNB LP',
  //   lpAddresses: {
  //     338: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
  //     25: '0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16',
  //   },
  //   token: serializedTokens.busd,
  //   quoteToken: serializedTokens.wbnb,
  // },
  {
    pid: 1,
    lpSymbol: 'CRO-ETH LP',
    lpAddresses: {
      338: '0xD37d267B2161035A9CF2023F9753CddbfC8B90F3',
      25: '0xA111C17f8B8303280d3EB01BBcd61000AA7F39F9',
    },
    token: serializedTokens.eth,
    quoteToken: serializedTokens.wcro,
  },
  {
    pid: 2,
    lpSymbol: 'CRO-WBTC LP',
    lpAddresses: {
      338: '0xbDAA80e9EA59bFD3A8AE5705c66804F2e1D9D508',
      25: '0x8F09fFf247B8fDB80461E5Cf5E82dD1aE2EBd6d7',
    },
    token: serializedTokens.wbtc,
    quoteToken: serializedTokens.wcro,
  },    
  {
    pid: 3,
    lpSymbol: 'CRO-USDC LP',
    lpAddresses: {
      338: '0x5323D7CE6a12282c0448d255d8B5EDc9918E52Da',
      25: '0xe61Db569E231B3f5530168Aa2C9D50246525b6d6',
    },
    token: serializedTokens.usdc,
    quoteToken: serializedTokens.wcro,
  },
  {
    pid: 4,
    lpSymbol: 'CRO-VVS LP',
    lpAddresses: {
      338: '0x3F3465b412B6017E20AF7ABFFAB67698de8cFa7a',
      25: '0xbf62c67eA509E86F07c8c69d0286C0636C50270b',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.wcro,
  },
  {
    pid: 5,
    lpSymbol: 'VVS-USDC LP',
    lpAddresses: {
      338: '0x9e3A0434ED428dFDe5ace779ead35e141DD95eFf',
      25: '0x814920d1b8007207db6cb5a2dd92bf0b082bdba1',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.usdc,
  },
  {
    pid: 6,
    lpSymbol: 'USDC-USDT LP',
    lpAddresses: {
      338: '',
      25: '0x39cC0E14795A8e6e9D02A21091b81FE0d61D82f9',
    },
    token: serializedTokens.usdt,
    quoteToken: serializedTokens.usdc,
  },
  {
    pid: 7,
    lpSymbol: 'VVS-USDT LP',
    lpAddresses: {
      338: '',
      25: '0x280aCAD550B2d3Ba63C8cbff51b503Ea41a1c61B',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.usdt,
  },
  {
    pid: 8,
    lpSymbol: 'CRO-SHIB LP',
    lpAddresses: {
      338: '',
      25: '0xc9eA98736dbC94FAA91AbF9F4aD1eb41e7fb40f4',
    },
    token: serializedTokens.shib,
    quoteToken: serializedTokens.wcro,
  },
  {
    pid: 9,
    lpSymbol: 'CRO-USDT LP',
    lpAddresses: {
      338: '',
      25: '0x3d2180DB9E1B909f35C398BC39EF36108C0FC8c3',
    },
    token: serializedTokens.usdt,
    quoteToken: serializedTokens.wcro,
  },
  {
    pid: 10,
    lpSymbol: 'CRO-DAI LP',
    lpAddresses: {
      338: '',
      25: '0x3Eb9FF92e19b73235A393000C176c8bb150F1B20',
    },
    token: serializedTokens.dai,
    quoteToken: serializedTokens.wcro,
  },
  {
    pid: 11,
    lpSymbol: 'CRO-BIFI LP',
    lpAddresses: {
      338: '',
      25: '0x1803E360393A472beC6E1A688BDF7048d3076b1A',
    },
    token: serializedTokens.bifi,
    quoteToken: serializedTokens.wcro,
  },
  {
    pid: 12,
    lpSymbol: 'CRO-DOGE LP',
    lpAddresses: {
      338: '',
      25: '0x2A560f2312CB56327AD5D65a03F1bfEC10b62075',
    },
    token: serializedTokens.doge,
    quoteToken: serializedTokens.wcro,
  },
]

const testnetFarms: SerializedFarmConfig[] = [
  /**
   * These 3 farms (PID 0, 251, 252) should always be at the top of the file.
   */
  {
    pid: 0,
    lpSymbol: 'VVS',
    lpAddresses: {
      338: '0x904Bd5a5AAC0B9d88A0D47864724218986Ad4a3a',
      25: '',
    },
    token: serializedTokens.workbench,
    quoteToken: serializedTokens.wcro,
  },
  {
    pid: 1,
    lpSymbol: 'CRO-ETH LP',
    lpAddresses: {
      338: '0xD37d267B2161035A9CF2023F9753CddbfC8B90F3',
      25: '',
    },
    token: serializedTokens.eth,
    quoteToken: serializedTokens.wcro,
  },
  {
    pid: 2,
    lpSymbol: 'CRO-WBTC LP',
    lpAddresses: {
      338: '0xbDAA80e9EA59bFD3A8AE5705c66804F2e1D9D508',
      25: '',
    },
    token: serializedTokens.wbtc,
    quoteToken: serializedTokens.wcro,
  },
  {
    pid: 3,
    lpSymbol: 'CRO-VVS LP',
    lpAddresses: {
      338: '0x3F3465b412B6017E20AF7ABFFAB67698de8cFa7a',
      25: '',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.wcro,
  },
  // deprecated
  // {
  //   pid: 4,
  //   lpSymbol: 'CRO-USDC LP',
  //   lpAddresses: {
  //     338: '0x5323D7CE6a12282c0448d255d8B5EDc9918E52Da',
  //     25: '',
  //   },
  //   token: serializedTokens.usdc,
  //   quoteToken: serializedTokens.wcro,
  // },
  {
    pid: 5,
    lpSymbol: 'VVS-USDC LP',
    lpAddresses: {
      338: '0x9e3A0434ED428dFDe5ace779ead35e141DD95eFf',
      25: '',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.usdc,
  },
  {
    pid: 6,
    lpSymbol: 'CRO-USDC LP',
    lpAddresses: {
      338: '0xaC7901EFB1F279a18e3f1973664cF4057DdbF0d9',
      25: '',
    },
    token: serializedTokens.usdc,
    quoteToken: serializedTokens.wcro,
  },
  {
    pid: 7,
    lpSymbol: 'USDC-USDT LP',
    lpAddresses: {
      338: '0xFd8e08cEEA14eC83277518ec892A7f17CB04a06a',
      25: '',
    },
    token: serializedTokens.usdt,
    quoteToken: serializedTokens.usdc,
  },
  {
    pid: 8,
    lpSymbol: 'VVS-USDT LP',
    lpAddresses: {
      338: '0x21D3283f9519D99Ca598a68DC23F286e244Df820',
      25: '',
    },
    token: serializedTokens.vvs,
    quoteToken: serializedTokens.usdt,
  },
  {
    pid: 9,
    lpSymbol: 'CRO-SHIB LP',
    lpAddresses: {
      338: '0x502494fa12459568c2f57bE01636b0724cc95190',
      25: '',
    },
    token: serializedTokens.shib,
    quoteToken: serializedTokens.wcro,
  },
  // {
  //   pid: 10,
  //   lpSymbol: 'VVS-PIZZA LP',
  //   lpAddresses: {
  //     338: '0x502494fa12459568c2f57bE01636b0724cc95190',
  //     25: '',
  //   },
  //   token: serializedTokens.pizza,
  //   quoteToken: serializedTokens.vvs,
  // },
  // {
  //   pid: 11,
  //   lpSymbol: 'USDC-PIZZA LP',
  //   lpAddresses: {
  //     338: '0x555302ED60Fd293A79C6bA0d05e8711a53c9a7Ce',
  //     25: '',
  //   },
  //   token: serializedTokens.pizza,
  //   quoteToken: serializedTokens.usdc,
  // },
  {
    pid: 12,
    lpSymbol: 'CRO-PIZZA LP',
    lpAddresses: {
      338: '0x65741A08Ecfa072A92862c2822Ffa3f83b3c10F9',
      25: '',
    },
    token: serializedTokens.pizza,
    quoteToken: serializedTokens.wcro,
  },
]

const farms: SerializedFarmConfig[] = process.env.REACT_APP_CHAIN_ID === ChainId.MAINNET.toString()
  ? mainnetFarms
  : testnetFarms

export default farms
